import Entity from "entity";

export default class Equipamento extends Entity {
    static get collectionUID() {
        return "ValueCustomForm/TRDvxUEKVxp95nFcIzR1/Values";
    }

    static async onQuery(collection) {
        return collection.where("status", "==", "ATIVO")
    }

    async initialize() {
        this.data.status = "ATIVO"
    }

    static get labelField() {
        return "equipamento";
    }

    static get searchColumns() {
        return [
            { field: "sequencialIndex", headerName: "Código", flex: 0.8, filter: true },
            { field: "cliente.nome", headerName: "Cliente", flex: 1, filter: true },
            { field: "equipamento", headerName: "Equipamento", flex: 1, filter: true },
            { field: "servico", headerName: "Serviço", flex: 1, filter: true },
        ];
    }
}
